var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-disclosure-dropdown',{attrs:{"items":_vm.items,"icon":"ellipsis_v","no-caret":"","toggle-text":_vm.$options.i18n.actions,"text-sr-only":"","placement":"right","category":"tertiary"}})
}
var staticRenderFns = []

export { render, staticRenderFns }